import { Box } from '@chakra-ui/react';
import { Pressable, VStack, Text } from 'components/ui';
import { FORM_ACTIONS } from '../../../utils/formActions.js';
import { cacheFormDataInLocalStorage } from '../../../utils/formReducer.js';
import { Pill } from '../Pill';

export const SEX_OPTIONS = ['Male', 'Female', 'Intersex'];

export const Sex = ({ dispatch, formData }) => {
  const updateSex = (data) => {
    const cacheData = JSON.stringify({ ...formData, sex: data });
    cacheFormDataInLocalStorage(cacheData);
    dispatch({
      type: FORM_ACTIONS.UPDATE_FORM_FIELD,
      fieldName: `sex`,
      payload: data,
    });
  };

  return (
    <VStack data-testid="onboarding-sex" gap="10px" alignItems={'flex-start'}>
      <Text textStyle="label.section" textAlign="left">
        Sex assigned at birth
      </Text>

      <Box display="flex" flexDirection="row" flexWrap="wrap" gap="9px">
        {SEX_OPTIONS.map((option) => (
          <Pressable
            key={option}
            onClick={() => updateSex(option)}
            data-testid={'onboarding-sex-item'}
          >
            <Pill isSelected={formData.sex === option} text={option} />
          </Pressable>
        ))}
      </Box>
    </VStack>
  );
};

export default Sex;
